import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Loading from 'vue-loading-overlay';
import VueSession from 'vue-session'


import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'vue-loading-overlay/dist/vue-loading.css';
import '@kouts/vue-modal/dist/vue-modal.css';

Vue.config.productionTip = false
Vue.use(Loading);
Vue.use(VueSession);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
